import React from 'react';
import styles from '../AnnouncementsV2.module.css';

const DateRangeFilter = ({ fromDate, toDate, onFromDateChange, onToDateChange, onClear }) => {
  return (
    <div className={styles.dateRangeFilter}>
      <div className={styles.dateInputGroup}>
        <label className={styles.dateLabel}>From Date</label>
        <input
          type="date"
          className={styles.dateInput}
          value={fromDate}
          onChange={(e) => onFromDateChange(e.target.value)}
        />
      </div>
      <div className={styles.dateInputGroup}>
        <label className={styles.dateLabel}>To Date</label>
        <input
          type="date"
          className={styles.dateInput}
          value={toDate}
          onChange={(e) => onToDateChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default DateRangeFilter;
